export default __webpack_public_path__ + "948400d00aca7fb6df3da8217ecbd3c6.svg";